import { render, staticRenderFns } from "./StackedColumnsChart.vue?vue&type=template&id=3c13b94a&"
import script from "./StackedColumnsChart.vue?vue&type=script&lang=js&"
export * from "./StackedColumnsChart.vue?vue&type=script&lang=js&"
import style0 from "./StackedColumnsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports